import { Banner, Faq, IoTDevelopmentServices, IoTSolution, KeyFeaturesCard, ProcessSlider, TechnologiesWeUseFor, VisionCTA } from "./components";

function IoTDevelopment(){
  return(
      <div className="  space-y-20 md:space-y-32 mb-20 md:mb-32">
   <Banner/>
   <IoTSolution/>
    <IoTDevelopmentServices/>
    <KeyFeaturesCard/>
    <VisionCTA/>
    <TechnologiesWeUseFor/>
    <ProcessSlider/>
    <Faq/>
   </div>
  )
}

export default IoTDevelopment;